import React from 'react';
import { DUTY_ICONS } from './constants';

export const getDutyIcon = (key: string): React.ComponentType<{ sx?: any }> | null => {
  return DUTY_ICONS[key] || null;
};